export const MIN_PAIRS_COUNT = 1
export const MAX_PAIRS_COUNT = 100
